(function ClientOpportunities($, Adzuki)
{
	"use strict";
	var chart,
	    graph,
	    opp_stage,
	    stage_days,
	    stage_distribution,
	    outcome_distribution,
	    opp_projected,
	    opp_projected_travel_types,
	    opp_projected_travel_dates,
	    opp_projected_close_dates,
	    chart_data      = {},
	    cache_ajax_data = true;

	$(document).ready(function documentReady()
	{
		var modal_pages = [
			'ClientOpportunities/manageEmails',
			'ClientOpportunities/timeline',
			'ClientOpportunities/touchpoints'
		];

		$("#client_opportunity_view .inline-edit").click(function toggle(event) {
			var $self       = $(this),
			    $view       = $self.closest('.view-table'),
			    $parent_div = $view.parent('div'),
			    $edit       = $parent_div.find('.edit-table');

			event.preventDefault();

			$view.toggleClass('hidden');
			$edit.toggleClass('hidden');
		});

		// no longer being used - eventually delete
		$(".content").on("click", ".archive-follow-up", function confirming(event)
		{
			var $self          = $(this),
			    id             = $self.data('id'),
			    opportunity_id = $self.data('opportunity_id'),
			    hide_add_link  = 0,
			    reload_url     = '/ClientOpportunityFollowups/ajaxReloadList/' + opportunity_id,
			    client_id;

			event.preventDefault();

			if ($('#followup_hide_add_link').length > 0) {
				hide_add_link = 1;
			}

			if ($self.hasClass('reload-client')) {
				client_id  = $self.data('client-id');
				reload_url = '/ClientOpportunityFollowups/ajaxReloadListForClient/' + client_id;
			}

			Adzuki.CustomConfirm({
				body   : 'Are you sure you wish to archive this follow-up?',
				confirm: function yes() {
					// ajax archive the follow-up
					Adzuki.Ajax.get('/ClientOpportunityFollowups/ajaxArchive/' + id)
					.then(function success(response) {
						// success message
						Adzuki.StatusMessage('Success', 'Successfully archived follow-up');

						// reload followups table
						Adzuki.Ajax.get(reload_url + '/0/' + hide_add_link)
						.then(function populate(content) {
							// replace follow-ups list
							$('#client_opportunity_follow_ups').replaceWith(content);
						});

						// ajax reload archived follow-ups
						Adzuki.Ajax.get(reload_url + '/1/' + hide_add_link)
						.then(function populate(content) {
							// replace follow-ups list
							$('#archived_client_opportunity_follow_ups').replaceWith(content);
						});
					});
				}
			});
		});

		// no longer being used - eventually delete
		$(".content").on("click", ".un-archive-follow-up", function confirming(event)
		{
			var $self          = $(this),
			    id             = $self.data('id'),
			    opportunity_id = $self.data('opportunity_id'),
			    hide_add_link  = 0,
			    reload_url     = '/ClientOpportunityFollowups/ajaxReloadList/' + opportunity_id,
			    client_id;

			event.preventDefault();

			if ($('#followup_hide_add_link').length > 0) {
				hide_add_link = 1;
			}

			if ($self.hasClass('reload-client')) {
				client_id  = $self.data('client-id');
				reload_url = '/ClientOpportunityFollowups/ajaxReloadListForClient/' + client_id;
			}

			Adzuki.CustomConfirm({
				body   : 'Are you sure you wish to un-archive this follow-up?',
				confirm: function yes() {
					// ajax un-archive the follow-up
					Adzuki.Ajax.get('/ClientOpportunityFollowups/ajaxUnarchive/' + id)
					.then(function success(response) {
						// success message
						Adzuki.StatusMessage('Success', 'Successfully un-archived follow-up');

						// reload followups table
						Adzuki.Ajax.get(reload_url + '/0/' + hide_add_link)
						.then(function populate(content) {
							// replace follow-ups list
							$('#client_opportunity_follow_ups').replaceWith(content);
						});

						// ajax reload archived follow-ups
						Adzuki.Ajax.get(reload_url + '/1/' + hide_add_link)
						.then(function populate(content) {
							// replace follow-ups list
							$('#archived_client_opportunity_follow_ups').replaceWith(content);
						});
					});
				}
			});
		});

		// handle removing individual sales opp search criteria
		$("#opportunity_filter_criteria .remove").click(function toggle(event) {
			var $self        = $(this),
			    filter_key   = $self.data('filter-key'),
			    filter_value = $self.data('filter-value'),
			    archived     = $self.data('archived'),
			    url          = Adzuki.base_uri + '/ClientOpportunities/removeFilterCriteria/' + archived + '/' + filter_key;

			if (filter_value !== undefined) {
				url += '/' + filter_value;
			}

			window.location.href = url;
		});

		// handle task details from manage sales opp page
		$('.so-task-details').off().on('click', _openTaskDetails);

		// for some reason the below is not happening
		Adzuki.onload('ClientOpportunities/index', function onload() {
			$("#opportunity_filter_criteria .remove").click(function toggle(event) {
				var $self        = $(this),
				    filter_key   = $self.data('filter-key'),
				    filter_value = $self.data('filter-value'),
				    archived     = $self.data('archived'),
				    url          = Adzuki.base_uri + '/ClientOpportunities/removeFilterCriteria/' + archived + '/' + filter_key;

				if (filter_value !== undefined) {
					url += '/' + filter_value;
				}

				window.location.href = url;
			});
		});

		// no longer being used - eventually delete
		Adzuki.onload('ClientOpportunities/associates', function onload() {
			$("#ClientOpportunityAssociatesForm #associate").change(function filter(event) {
				var $self       = $(this),
					dd_value    = $self.val(),
				    url         = Adzuki.get_url("/ClientOpportunities/associates/" + dd_value);

				if (dd_value.length > 0) {
					window.location = url;
				}
			});
		});

		// no longer being used - eventually delete
		Adzuki.onload('ClientOpportunities/cpHub', function onload() {
			chart = new Adzuki.Chart('#cphub-chart', {
				width : '100%',
				height: 475
			});

			$(chart).on('ready', function setChartData() {
				initChart('pipeline_data', drawPipelineChart, '/ClientOpportunities/pipelineDistribution', chart, 'chart-spinner');
			});

			graph = new Adzuki.Chart('#cphub-graph', {
				width : '100%',
				height: 500
			});

			$(graph).on('ready', function setGraphData() {
				initSixMonthGraph(graph, 'graph-spinner');
			});

			$('.cp-hub-pipe').click(function cpHubPipelineClick() {
				chartButtonSelected($(this));
				initChart('pipeline_data', drawPipelineChart, '/ClientOpportunities/pipelineDistribution', chart, 'chart-spinner');
			});

			$('.cp-hub-opp-per-stage').click(function opportunitiesPerStageClick() {
				chartButtonSelected($(this));
				initChart('opportunities_per_stage', generateOpportunitiesPerStage, '/ClientOpportunities/opportunitiesPerStage', chart, 'chart-spinner');
			});

			$('.cp-hub-val-travel-type').click(function valueByTravelTypeClick() {
				chartButtonSelected($(this));
				initChart('value_by_travel_type', generateValueByTravelType, '/ClientOpportunities/valueByTravelType', chart, 'chart-spinner');
			});

			$('.cp-hub-graph-6months').click(function nextSixMonths() {
				toggleDateRangeForm(false);
				chartButtonSelected($(this));
				initSixMonthGraph(graph, 'graph-spinner');
			});

			$('.cp-hub-graph-12months').click(function nextTwelveMonths() {
				var next_month = getMysqlDateString(1),
				    end_month  = getMysqlDateString(13);

				toggleDateRangeForm(false);
				chartButtonSelected($(this));
				initChart('twelve_month_data', drawLineGraphProjected, '/ClientOpportunities/pipelineByDate/' + next_month + '/' + end_month, graph, 'graph-spinner');
			});

			$('.cp-hub-graph-custom-date').click(function nextCustomMonths() {
				toggleDateRangeForm(true);
				chartButtonSelected($(this));
				initCustomGraph(graph, 'graph-spinner');
			});

			$('.cp-hub-submit-custom-date-graph').click(function generateCustomMonths() {
				initCustomGraph(graph, 'graph-spinner');
			});
		});

		// for viewing things
		Adzuki.onload(modal_pages, function onload()
		{
			// email sent from sales opp
			$('.sent-email').click(function showEmail(e) {
				var $self          = $(this),
				    $modal         = $(".modal"),
				    modal_title    = $self.data("modal-title"),
				    iframe_src     = $self.data("iframe-src"),
				    iframe_height  = $self.data("iframe-height") || 500,
				    iframe_width   = $self.data("iframe-width") || '100%';

				e.preventDefault();

				$modal.addClass('wide');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			// cruise, hotel, resort, tour comparisons
			$('.comparison').click(function showComparisonEmail(e) {
				var $self          = $(this),
				    $modal         = $(".modal"),
				    modal_title    = $self.data("modal-title"),
				    iframe_src     = $self.data("iframe-src"),
				    iframe_height  = $self.data("iframe-height") || 500,
				    iframe_width   = $self.data("iframe-width") || '100%';

				e.preventDefault();

				$modal.addClass('wide');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			// view ecard
			Adzuki.Erez.Ecards.viewByType('ecard');

			// view email builder
			$('.eb-view-email').click(function onViewEmailClick(e) {
				var $target      = $(e.currentTarget);
				var $modal_title = $('.modal-title');
				var $modal_body  = $('.modal-body');
				var model_id     = $target.data('model-id');

				e.preventDefault();

				Adzuki.Ajax.get('/EmailBuilders/view/' + model_id)
				.then(function success(response)
				{
					$('#modalWindow').modal();

					$modal_title.html('View Email');
					$modal_body.html(response);
				});


				// var $modal           = $(".modal"),
				// 	email_builder_id = $(this).data('model-id');

				// e.preventDefault();

				// Adzuki.Ajax.get('/EmailBuilders/view/' + email_builder_id)
				// .then(function success(response)
				// {
				// 	$('#modalWindow').modal();

				// 	modal_title.html('View Email');
				// 	modal_body.html(response);
				// });
			});

			// view a bucket from sales opp touchpoints
			$('.view-client-bucket').click(function onViewBucket(e)
			{
				var $self     = $(this),
				    bucket_id = $self.data('bucket-id');

				e.preventDefault();

				Adzuki.Buckets.openBuckets(bucket_id);
			});
		}, false);

		Adzuki.onload('ClientOpportunityAttachments/forOpportunity', function onload() {
			$('.task-details').off().on('click', _openTaskDetails);
		});

		// Might need to change this at some point
		// This is a little hacky, but we are going to generate the Sales Pipeline charts within the reports section here. If there is an Erez object at some point, we might want to revise
		// how this is being done.
		Adzuki.onload('Reports/salesPipeline', function onload() {
			// Number of Open Opportunities by Stage
			opp_stage = new Adzuki.Chart('#report-opp-stage', {
				width : '100%',
				height: 400
			});

			$(opp_stage).on('ready', function oppStageData() {
				initChart('opportunities_per_stage', generateOpportunitiesPerStage, '/ClientOpportunities/opportunitiesPerStage', opp_stage, 'report-opp-stage-spinner');
			});

			// Average Days in Stage
			stage_days = new Adzuki.Chart('#report-stage-days', {
				width : '100%',
				height: 400
			});

			$(stage_days).on('ready', function stageDaysData() {
				initChart('days_open_per_stage', generateDaysOpenPerStage, '/ClientOpportunities/opportunitiesAverageDaysPerStage', stage_days, 'report-stage-days-spinner');
			});

			// Stage Distribution
			stage_distribution = new Adzuki.Chart('#report-stage-distribution', {
				width : '100%',
				height: 400
			});

			$(stage_distribution).on('ready', function stageDistributionData() {
				initChart('stage_distribution', generateOpportunitiesStageDistribution, '/ClientOpportunities/opportunitiesPerStage/1', stage_distribution, 'report-stage-distribution-spinner');
			});

			// Outcome Distribution
			outcome_distribution = new Adzuki.Chart('#report-outcome-distribution', {
				width : '100%',
				height: 400
			});

			$(outcome_distribution).on('ready', function outcomeDistributionData() {
				initChart('outcome_distribution', generateOpportunitiesOutcomeDistribution, '/ClientOpportunities/opportunitiesPerClosedResult', outcome_distribution, 'report-stage-distribution-spinner');
			});

			// Future Projected Sales Value by Stage
			opp_projected = new Adzuki.Chart('#report-opp-projected', {
				width : '100%',
				height: 400
			});

			$(opp_projected).on('ready', function valueByStageData() {
				var next_month = getMysqlDateString(1),
				    end_month  = getMysqlDateString(13);

				initChart('twelve_month_data', drawLineGraphProjected, '/ClientOpportunities/pipelineByDate/' + next_month + '/' + end_month, opp_projected, 'report-opp-projected-spinner');
			});

			// Future Projected Sales Value by Travel Type
			opp_projected_travel_types = new Adzuki.Chart('#report-opp-projected-travel-type', {
				width : '100%',
				height: 400
			});

			$(opp_projected_travel_types).on('ready', function valueByTravelTypeData() {
				var next_month = getMysqlDateString(1),
				    end_month  = getMysqlDateString(13);

				initChart('twelve_month_data', drawLineGraphProjectedTravelType, '/ClientOpportunities/pipelineByDateTravelType/' + next_month + '/' + end_month, opp_projected_travel_types, 'report-opp-projected-travel-type-spinner');
			});

			// Future Projected Sales Value by Travel Dates
			opp_projected_travel_dates = new Adzuki.Chart('#report-opp-projected-travel-dates', {
				width : '100%',
				height: 400
			});

			$(opp_projected_travel_dates).on('ready', function valueByTravelDatesData() {
				var next_month = getMysqlDateString(1),
				    end_month  = getMysqlDateString(13);

				initChart('twelve_month_data', generateValueByTravelDates, '/ClientOpportunities/pipelineByEstimatedTravelDate/' + next_month + '/' + end_month, opp_projected_travel_dates, 'report-opp-projected-travel-dates-spinner');
			});

			// Future Projected Sales Value by Close Dates
			opp_projected_close_dates = new Adzuki.Chart('#report-opp-projected-close-dates', {
				width : '100%',
				height: 400
			});

			$(opp_projected_close_dates).on('ready', function valueByCloseDatesData() {
				var next_month = getMysqlDateString(1),
				    end_month  = getMysqlDateString(13);

				initChart('twelve_month_data', generateValueByCloseDates, '/ClientOpportunities/pipelineByEstimatedCloseDate/' + next_month + '/' + end_month, opp_projected_close_dates, 'report-opp-projected-close-dates-spinner');
			});
		});

		Adzuki.onload('ClientOpportunities/manageTasks/', function onload()
		{
			Adzuki.TaskManager.loadEntityTasks('sales_op');
		});

		Adzuki.onload('ClientOpportunities/view', function onload()
		{
			// for view task details
			$('.task-details').off().on('click', _openTaskDetails);

			// toggle client recap box (if included in the element)
			$('#client_recap').on('click', function onToggleClick(e)
			{
				var $self = $(this);
				$self.toggleClass('plus');
				$self.toggleClass('minus');

				$('.client-recap').collapse('toggle');
			});

			// for "sneek peek" on reservation list
			$('.reservation-peek').on('click', '.reservation-details', function showReservationDetails(e)
			{
				var $modal = $(".modal");

				e.preventDefault();
				$modal.find('.modal-body').text('Loading reservation details...');
				$modal.find('.modal-title').text('Reservation Details');
				$modal.modal('show');

				Adzuki.Ajax.get('/Reservations/reservationDetailsModal/'+$(this).data('reservation-id'))
				.then(function showDetails(data) {
					$modal.find('.modal-body').html(data);
				});
			});

			$("a.info-link").on('click', function showInfo(e)
			{
				var $self  = $(this),
				    $modal = $(".modal"),
				    body   = $self.data('content') || $($self.data('modal-id')).html();

				e.preventDefault();
				$modal.find('.modal-title').text($self.data('modal-title'));
				$modal.find('.modal-body').html(body);
				$modal.modal('show');
			});
		});
	});

	function _openTaskDetails(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.openTaskDetails($anchor_elem);
	}

	function chartButtonSelected($el)
	{
		var $group = $el.closest('.btn-group');
		$group.find('.btn').removeClass('active');
		$el.addClass('active');
	}

	// get the start and end date values and draw the graph
	function initCustomGraph(graph, spinner_id)
	{
		var next_month = $('#custom-start-year').val() + '-' + $('#custom-start-month').val() + '-01',
		    end_month  = $('#custom-end-year').val() + '-' + $('#custom-end-month').val() + '-01',
		    end_date   = moment(end_month).add(1, 'M').format("YYYY-MM-DD");

		cache_ajax_data = false;
		initChart('custom_month_data', drawLineGraphProjected, '/ClientOpportunities/pipelineByDate/' + next_month + '/' + end_date, graph, spinner_id);
	}

	/**
	 * Toggle the start and end date drop-downs for graphs section
	 * @param  boolean  show - true means to show, false means to hide them
	 */
	function toggleDateRangeForm(show)
	{
		if (show) {
			$('#custom-date-form').removeClass('hidden');
		} else {
			$('#custom-date-form').addClass('hidden');
		}
	}

	// get the start and end date values for the "next 6 months" graph and draw
	function initSixMonthGraph(graph, spinner_id)
	{
		var next_month = getMysqlDateString(1),
			end_month  = getMysqlDateString(7);

		initChart('six_month_data', drawLineGraphProjected, '/ClientOpportunities/pipelineByDate/' + next_month + '/' + end_month, graph, spinner_id);
	}

	/**
	 * Adds number of months to current date and returns first of da month for the calculated month
	 * @param  int    months_to_add  number of months in the future
	 * @return string                Returns a mysql date string
	 */
	function getMysqlDateString(months_to_add)
	{
		var date     = new Date(),
		date_string  = '';

		date.setMonth(date.getMonth() + months_to_add);
		date_string  = date.getFullYear() + '-' + (date.getMonth() + 1) + '-01';

		return date_string;
	}

	/**
	 * Toggles a loading gif. Should only be showing the loading gif when we are pulling the data from the charts via ajax since there might be a slight delay
	 * @param  string   element_id the id of the loading gif element
	 * @param  boolean  show       true to show, false to hide
	 */
	function toggleChartSpinner(element_id, show)
	{
		var $spinner = $('#' + element_id);
		if ($spinner) {
			if (show) {
				$spinner.removeClass('hidden');
			} else {
				$spinner.addClass('hidden');
			}
		}
	}

	/**
	 * Determines if the data for the chart/graph has already been cached or whether we need to get it fresh via ajax. If the data is cached, will call the function to build the chart with a cached array passed in.
	 * If not, calls function which pulls data via ajax and then passes it to the function which draws. Also determines which spinner_id we might have to show.
	 * @param  string    key            key in cache. indicates which chart/graph is being generated
	 * @param  function  function_name  The function should utilize charts.js to build a chart via google's api
	 * @param  string    ajax_path      a URL to call if we need to retrieve the data for the chart via ajax
	 */
	function initChart(key, function_name, ajax_path, chart, spinner_id)
	{
		// means we've already hit the ajax and got json data cached
		if ($.isArray(chart_data[key])) {
			function_name(chart_data[key], key, chart);

		// we need to get json data via ajax and then build chart
		} else {

			getAjaxDataAndBuildChart(ajax_path, function_name, spinner_id, key, chart);
		}
	}

	/**
	 * Get data via ajax and then passes it into callback function to draw chart
	 * @param  string     path       relative url
	 * @param  function   callback   function that draws the chart
	 * @param  string     spinner_id id of the loading gif for toggling
	 * @param  string     key        key in cache. indicates which chart/graph is being generated
	 */
	function getAjaxDataAndBuildChart(path, callback, spinner_id, key, chart)
	{
		toggleChartSpinner(spinner_id, true);

		Adzuki.Ajax.get(path)
		.then(function loadChartData(response) {

			// call whatever specific function name was passed in with json response as param.  This is the function that will draw the chart/graph
			callback(response, key, chart);

			toggleChartSpinner(spinner_id, false);
		})
		.catch(function error(err) {
			console.log(err);
		});
	}

	/**
	 * Caches initial ajax response so we don't hit the ajax more than one time per page load
	 * @param  string   key   key in cache
	 * @param  array    data  array of data needed for chart
	 */
	function cacheAjaxResponse(key, data)
	{
		// cache response
		if (cache_ajax_data) {
			chart_data[key] = data;
		}
	}

	/**
	 * draw the "Number of Open Opportunities by Stage" bar chart
	 * @param  array    jsonResponse  chart data for google
	 * @param  string   cache_key     key in cache for data
	 */
	function generateOpportunitiesPerStage(jsonResponse, cache_key, chart)
	{
		var barStyle = 'fill-color: #39B54A;';

		// Need to modify array for google charts
		$.each( jsonResponse, function loop( key, value ) {
			var new_val = value;


			if (key === 0) {
				// header. add obj to array
				new_val.push({role: 'style'});
			} else {
				// add style for each bar in chart
				new_val.push(barStyle);
			}

			jsonResponse[key] = new_val;
		});

		chart.opts['title']     = "Number of Open Opportunities by Stage";
		chart.opts['legend']    = "none";
		chart.opts['chartArea'] = {
			width: '70%'
		};
		chart.opts['hAxis']     = {
			title   : 'Number of Opportunities',
			minValue: 0
		};
		chart.opts['vAxis']     = {
			title: 'Stage'
		};

		cacheAjaxResponse(cache_key, jsonResponse);
		chart.setData(jsonResponse);
		chart.draw('bar');

		return;
	}

	/**
	 * draw the "Average Days in Stage" bar chart
	 * @param  array    jsonResponse  chart data for google
	 * @param  string   cache_key     key in cache for data
	 */
	function generateDaysOpenPerStage(jsonResponse, cache_key, chart)
	{
		// Need to modify array for google charts
		$.each( jsonResponse, function loop( key, value ) {
			var new_val = value;

			jsonResponse[key] = new_val;
		});

		chart.opts['title']     = "Average Days in Stage";
		chart.opts['legend']    = "none";
		chart.opts['chartArea'] = {
			width: '70%'
		};
		chart.opts['hAxis']     = {
			title   : 'Average Number of Days',
			minValue: 0
		};
		chart.opts['vAxis']     = {
			title: 'Stage'
		};

		cacheAjaxResponse(cache_key, jsonResponse);
		chart.setData(jsonResponse);
		chart.draw('bar');

		return;
	}

	/**
	 * draw the "Stage Distribution" pie chart
	 * @param  array    data       chart data for google
	 * @param  string   cache_key  key in cache for data
	 */
	function generateOpportunitiesStageDistribution(data, cache_key, chart)
	{
		var chart_total = 0,
		    value_key;

		// chart options
		chart.opts['title']  = "Stage Distribution";
		chart.opts['legend'] = true;

		$.each( data, function loop( key, value ) {
			for (value_key in value) {
				if ($.isNumeric(value[value_key])) {
					chart_total = chart_total + value[value_key];
				}
			}
		});

		if (chart_total > 0) {
			cacheAjaxResponse(cache_key, data);
			chart.setData(data);
			chart.draw('pie');
		} else {
			$('#report-stage-distribution').html('<strong>Stage Distribution</strong><br><em>No data available for Stage Distribution graph.</em>');
		}
	}

	/**
	 * draw the "Outcome Distribution" pie chart
	 * @param  array    data       chart data for google
	 * @param  string   cache_key  key in cache for data
	 */
	function generateOpportunitiesOutcomeDistribution(data, cache_key, chart)
	{
		var chart_total = 0,
		    value_key;

		// chart options
		chart.opts['title']  = "Outcome Distribution";
		chart.opts['legend'] = true;

		$.each( data, function loop( key, value ) {
			for (value_key in value) {
				if ($.isNumeric(value[value_key])) {
					chart_total = chart_total + value[value_key];
				}
			}
		});

		if (chart_total > 0) {
			cacheAjaxResponse(cache_key, data);
			chart.setData(data);
			chart.draw('pie');
		} else {
			$('#report-outcome-distribution').html('<strong>Outcome Distribution</strong><br><em>No data available for Outcome Distribution graph.</em>');
		}
	}

	/**
	 * draw the "Future Projected Sales Value by Stage" line graph
	 * @param  array    data          graph data for google
	 * @param  string   cache_key     key in cache for data
	 */
	function drawLineGraphProjected(data, cache_key, graph)
	{
		graph.opts['title']   = "Future Projected Sales Value by Stage";
		graph.opts['legend']  = true;
		graph.opts['hAxis']   = {
			title           : 'Estimated Travel Dates',
			slantedText     : true,
			slantedTextAngle: 45
		};
		graph.opts['vAxis']   = {
			format: '$#,###'
		};

		cacheAjaxResponse(cache_key, data);
		graph.setData(data);
		graph.format('Number', 1, {prefix: '$'});
		graph.draw('line');
	}

	/**
	 * draw the "Future Projected Sales Value by Travel Type" line graph
	 * @param  array    data          graph data for google
	 * @param  string   cache_key     key in cache for data
	 */
	function drawLineGraphProjectedTravelType(data, cache_key, graph)
	{
		graph.opts['title']   = "Future Projected Sales Value by Travel Type";
		graph.opts['legend']  = true;
		graph.opts['hAxis']   = {
			title           : 'Estimated Travel Dates',
			slantedText     : true,
			slantedTextAngle: 45
		};
		graph.opts['vAxis']   = {
			format: '$#,###'
		};

		cacheAjaxResponse(cache_key, data);
		graph.setData(data);
		graph.format('Number', 1, {prefix: '$'});
		graph.draw('line');
	}

	/**
	 * draw the "Future Projected Sales Value by Travel Date" line graph
	 * @param  array    data          chart data for google
	 * @param  string   cache_key     key in cache for data
	 */
	function generateValueByTravelDates(data, cache_key, graph)
	{
		graph.opts['title']   = "Future Projected Sales Value by Travel Date";
		graph.opts['legend']  = "none";
		graph.opts['hAxis']   = {
			title           : 'Estimated Travel Dates',
			slantedText     : true,
			slantedTextAngle: 45
		};
		graph.opts['vAxis']   = {
			format: '$#,###'
		};

		cacheAjaxResponse(cache_key, data);
		graph.setData(data);
		graph.format('Number', 1, {prefix: '$'});
		graph.draw('line');
	}

	/**
	 * draw the "Future Projected Sales Value by Close Date" line graph
	 * @param  array    data          chart data for google
	 * @param  string   cache_key     key in cache for data
	 */
	function generateValueByCloseDates(data, cache_key, graph)
	{
		graph.opts['title']   = "Future Projected Sales Value by Close Date";
		graph.opts['legend']  = "none";
		graph.opts['hAxis']   = {
			title           : 'Estimated Close Dates',
			slantedText     : true,
			slantedTextAngle: 45
		};
		graph.opts['vAxis']   = {
			format: '$#,###'
		};

		cacheAjaxResponse(cache_key, data);
		graph.setData(data);
		graph.format('Number', 1, {prefix: '$'});
		graph.draw('line');
	}

	// only used on old CP Marketing Hub "classic" dashboard
	/**
	 * draw the "Sales Pipeline Estimated Value Distribution" pie chart
	 * @param  array    data       chart data for google
	 * @param  string   cache_key  key in cache for data
	 */
	function drawPipelineChart(data, cache_key, chart)
	{
		chart.opts['title']        = "Sales Pipeline Estimated Value Distribution";
		chart.opts['is3D']         = true;
		chart.opts['legend']       = true;

		cacheAjaxResponse(cache_key, data);
		chart.setData(data);
		chart.format('Number', 1, {prefix: '$'});
		chart.draw('pie');
	}

	// only used on old CP Marketing Hub "classic" dashboard
	/**
	 * draw the "Travel Type Value" bar chart
	 * @param  array    jsonResponse  chart data for google
	 * @param  string   cache_key     key in cache for data
	 */
	function generateValueByTravelType(jsonResponse, cache_key, chart)
	{
		var barStyle = 'fill-opacity: 0.8;';

		// means it was initial ajax response and we need to append stuff, otherwise we don't want to append to cached stuff
		if (jsonResponse[0].length < 3) {

			// Need to modify array for google charts
			$.each( jsonResponse, function loop( key, value ) {
				var new_val          = value,
				    color            = '#000000',
				    adjustedBarStyle = barStyle;

				// header. add obj to array
				if (key === 0) {
					new_val.push({role: 'style'});

				// add style for each bar in chart
				} else {
					color = value[2];
					new_val.splice(2, 1);
					adjustedBarStyle += ' fill-color: ' + color;
					new_val.push(adjustedBarStyle);
				}
				jsonResponse[key] = new_val;
			});
		}

		chart.opts['title']     = "Potential Value by Travel Type";
		chart.opts['legend']    = "none";

		chart.opts['chartArea'] = {
			width: '70%'
		};
		chart.opts['hAxis']     = {
			title    : 'Dollars',
			minValue : 0,
			format   : '$#,###',
			gridlines: {count: 6 }
		};

		chart.opts['vAxis']     = {
			title: 'Travel Type'
		};

		cacheAjaxResponse(cache_key, jsonResponse);
		chart.setData(jsonResponse);
		chart.format('Number', 1, {prefix: '$'});
		chart.draw('bar');

		return;
	}
}(jQuery, window.Adzuki || {}));
